import styled from 'styled-components';

export default styled.div`
	background: var(--ds-body-bg);
	display: flex;
	flex: 1;
	min-height: 0;
`;
